import * as axios from './axios';
import * as client from './client/index';

export * from './client/index';

export const newAreasApi = (): client.AreasApi => {
  const ax = axios.newAxiosInstance();
  return new client.AreasApi(new client.Configuration(), '', ax);
};

export const newExploreAreasApi = (): client.ExploreAreasApi => {
  const ax = axios.newAxiosInstance();
  return new client.ExploreAreasApi(new client.Configuration(), '', ax);
};

export const newExploresApi = (): client.ExploresApi => {
  const ax = axios.newAxiosInstance();
  return new client.ExploresApi(new client.Configuration(), '', ax);
};

export const newExploreStationsApi = (): client.ExploreStationsApi => {
  const ax = axios.newAxiosInstance();
  return new client.ExploreStationsApi(new client.Configuration(), '', ax);
};

export const newMerchantsApi = (): client.MerchantsApi => {
  const ax = axios.newAxiosInstance();
  return new client.MerchantsApi(new client.Configuration(), '', ax);
};

export const newMerchantsCategoryApi = (): client.MerchantCategoriesApi => {
  const ax = axios.newAxiosInstance();
  return new client.MerchantCategoriesApi(new client.Configuration(), '', ax);
};

export const newStationsApi = (): client.StationsApi => {
  const ax = axios.newAxiosInstance();
  return new client.StationsApi(new client.Configuration(), '', ax);
};

export const newUcMerchantApi = (
  session?: string,
  token?: string,
): client.UcMerchantsApi => {
  const ax = axios.newAxiosInstance(session, token);
  return new client.UcMerchantsApi(new client.Configuration(), '', ax);
};

export const newPasswordProtectedApi = (
  session?: string,
  token?: string,
): client.PasswordProtectionsApi => {
  const ax = axios.newAxiosInstance(session, token);
  return new client.PasswordProtectionsApi(new client.Configuration(), '', ax);
};

export const newSessionApi = (): client.SessionsApi => {
  const ax = axios.newAxiosInstance();
  return new client.SessionsApi(new client.Configuration(), '', ax);
};
